export const getStyle = function (style) {
  switch (style) {
    case 'streets':
      return 'mapbox://styles/justswim/citdly5am00382hpbwajqhi5w'
    case 'light-streets':
      return 'mapbox://styles/justswim/ciwmdalxa00d42qqoyzkwgq2k'
    case 'basic':
      return 'mapbox://styles/justswim/citddk4hj002z2jp25vsoo6c5'
    case 'light':
      return 'mapbox://styles/justswim/citkfiieh00652ipk5v99uhyb'
    case 'dark':
      return 'mapbox://styles/justswim/citdx62xu004c2jp2nfivagzm'
    case 'satellite':
      return 'mapbox://styles/justswim/citfz8utn000i2jlmtnwhnfy4'
    case 'vintage':
      return 'mapbox://styles/justswim/citdx2xt500442ip106fcddjm'
    case 'whaam':
      return 'mapbox://styles/justswim/citdx3xab003w2hog3d2waleg'
    case 'ski':
      return 'mapbox://styles/justswim/citdww2qs003u2hog4r3qbcic'
    default:
      return 'mapbox://styles/justswim/citdly5am00382hpbwajqhi5w'
  }
}

export const getAccessToken = function () {
  return "pk.eyJ1IjoianVzdHN3aW0iLCJhIjoiY2lybzY2YXg2MGJiNXQxbms2czAxbGxjbSJ9.KGsVFwRl1SP5WUe0ma6MZQ"
}



// WEBPACK FOOTER //
// ./src/helpers/helpers.js